import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.auth.register');
import { OnInit, EventEmitter, Output, ChangeDetectorRef as CDR } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-auth-register',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.auth.register/view.scss */
:host {
  display: block;
}

button[type=submit]:active {
  transform: scale(0.98);
}

.error-msg {
  animation: errorAppear 0.2s ease-out;
}

@keyframes errorAppear {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}`],
})
export class ComponentAuthRegisterComponent implements OnInit {
    @Output() public changeMode = new EventEmitter<string>();

    public data: any = {
        id: '',
        password: '',
        password_confirm: '',
        name: '',
        email: '',
        department: '건축'
    };

    public errors: any = {};

    constructor(@Inject( Service)         public service: Service,@Inject( CDR    )         public ref: CDR    ) { }

    public async ngOnInit(): Promise<void> {
        await this.service.render();
    }

    private async alert(message: string, status: string = 'error') {
        await this.service.alert.show({
            title: status === 'success' ? '성공' : '알림',
            message: message,
            status: status,
            action: '확인',
            cancel: false
        });
    }

    public async selectDept(value: string) {
        this.data.department = value;
        await this.service.render();
    }

    public validate(): boolean {
        this.errors = {};

        if (!this.data.id || this.data.id.trim() === '') {
            this.errors.id = '아이디를 입력해주세요.';
        } else if (this.data.id.length < 4) {
            this.errors.id = '아이디는 4자 이상이어야 합니다.';
        } else if (!/^[a-zA-Z0-9_]+$/.test(this.data.id)) {
            this.errors.id = '아이디는 영문, 숫자, 언더스코어만 사용 가능합니다.';
        }

        if (!this.data.name || this.data.name.trim() === '') {
            this.errors.name = '이름을 입력해주세요.';
        } else if (this.data.name.length < 2) {
            this.errors.name = '이름은 2자 이상이어야 합니다.';
        }

        if (!this.data.email || this.data.email.trim() === '') {
            this.errors.email = '이메일을 입력해주세요.';
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.data.email)) {
            this.errors.email = '올바른 이메일 형식이 아닙니다.';
        }

        if (!this.data.password || this.data.password === '') {
            this.errors.password = '비밀번호를 입력해주세요.';
        } else if (this.data.password.length < 6) {
            this.errors.password = '비밀번호는 6자 이상이어야 합니다.';
        }

        if (!this.data.password_confirm || this.data.password_confirm === '') {
            this.errors.password_confirm = '비밀번호 확인을 입력해주세요.';
        } else if (this.data.password !== this.data.password_confirm) {
            this.errors.password_confirm = '비밀번호가 일치하지 않습니다.';
        }

        return Object.keys(this.errors).length === 0;
    }

    public async register() {
        if (!this.validate()) {
            const firstError = Object.values(this.errors)[0] as string;
            await this.alert(firstError);
            await this.service.render();
            return;
        }

        let user = JSON.parse(JSON.stringify(this.data));
        delete user.password_confirm;
        user.password = this.service.auth.hash(user.password);

        let { code, data } = await wiz.call('register', user);
        if (code == 200) {
            await this.alert('성공적으로 가입되었습니다. 로그인 페이지로 이동합니다.', 'success');
            location.reload();
        }

        await this.alert(data);
    }

    public gotoLogin() {
        this.changeMode.emit('login');
    }
}

export default ComponentAuthRegisterComponent;